<template lang="pug">
  el-dialog.m-width-popup(
    title='Reset password',
    :visible='showResetPasswordDialog',
    top='12vh',
    :show-close=false
  ).mb-3
    el-form(
        ref='changePassoword'
        :model='changePassoword'
        label-position='top'
        :rules='rules'
        @submit.native.prevent='validatePasswordForm("changePassoword")'
      )
        el-form-item(label='Current Password:' prop='olduserPass')
          el-input(
            v-model='changePassoword.olduserPass'
            placeholder='Current Password'
            type='password'
          )

        el-form-item(label='New Password:' prop='newuserPass').el-hint-text-relative
          el-input(
            v-model='changePassoword.newuserPass'
            placeholder='New Password'
            type='password'
          )

        el-form-item(label='Repeat New Password:' prop='confirmPassword').mb-0
          el-input(
            v-model='changePassoword.confirmPassword'
            placeholder='Repeat New Password'
            type='password'
          )
    h6.py-4
      | Passwords must be 8 or more characters and contain 1 special character (!$&*), 1 lower case, 1 upper case letter and 1 number.

    .dialog-footer(slot='footer')
       el-button(
          type='success'
          @click='validatePasswordForm("changePassoword")'
        ) Change Password


</template>

<script>
import { mapGetters, mapActions } from 'vuex';


export default {
  name: 'ResetPasswordDialog',
  props: {
    showResetPasswordDialog: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    const validatePass2 = (_, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter confirm password'));
      } else if (value !== this.changePassoword.newuserPass) {
        callback(new Error('Password and confirm password don\'t match!'));
      } else {
        callback();
      }
    };
    const validatePass = (_, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter new password'));
      } else if (value.length < 8 || value.search(/[a-z]/) < 0 || value.search(/\d/) < 0
        || value.search(/[A-Z]/) < 0 || value.search(/[!@#$%^&*_-]/) < 0) {
        callback(new Error('Password does not meet requirements: 8 or more characters, 1 special character (!$&*), 1 Number, 1 lower case and 1 upper case letter.'));
      } else {
        callback();
      }
    };
    return {
      changePassoword: {
        email: '',
        olduserPass: '',
        newuserPass: '',
        confirmPassword: '',
      },
      rules: {
        olduserPass: { required: true, message: 'Current password is required', trigger: 'blur' },
        newuserPass: [
          { validator: validatePass, trigger: 'blur' },
        ],
        confirmPassword: [
          { validator: validatePass2, trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters('shared', ['loading']),
    ...mapGetters('users', ['changePasswordreply', 'me']),
  },
  watch: {
    changePasswordreply(changePasswordResponse) {
      if (changePasswordResponse && changePasswordResponse.Message === 'SUCCESS') {
        this.$message({
          message: 'Password changed successfully.',
          type: 'success',
        });
        //
        this.updateUserPass({ id: this.me.id, password: this.changePassoword.newuserPass });
        // Call parent method to close this dialog
        this.$emit('handlePasswordChange');
      } else if (changePasswordResponse.Message.message) {
        this.$message({
          message: changePasswordResponse.Message.message,
          type: 'error',
        });
      } else {
        this.$message({
          message: changePasswordResponse.Message,
          type: 'error',
        });
      }
    },
  },

  methods: {
    ...mapActions('users', ['getCurrentUser', 'resetPassword', 'updateUserPass']),

    // Validate for befire submit
    validatePasswordForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.submitPasswordForm();
        }
        return false;
      });
    },

    // for chage password
    submitPasswordForm() {
      this.resetPassword({
        email: this.me.email,
        olduserPass: this.changePassoword.olduserPass,
        newuserPass: this.changePassoword.newuserPass,
      });
    },
  },


};
</script>
